import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useAppSelector } from '../../redux/store';
import { DealingMessageDisplay } from './dealingMessageDisplay';
export const DealingMessageContainer = () => {
    const isShowingDealingMessage = useAppSelector((state) => state.poker.isShowingDealingMessage);
    const hasStatusMessage = useAppSelector((state) => !!state.poker.statusMessage);
    const dealingMessageText = useAppSelector((state) => {
        if (state.poker.isAllInGame) {
            return 'ALL-IN?!';
        }
        return "DEALIN'";
    });
    const hasCommunityCards = useAppSelector((state) => !!state.poker.communityCards.length || !!state.poker.rabbits.length);
    const tableAreaDimensionsW = useAppSelector((state) => state.gameDimensions.tableAreaDimensions?.w);
    const tableAreaDimensionsH = useAppSelector((state) => state.gameDimensions.tableAreaDimensions?.h);
    const dealingMessageTextColor = useAppSelector((state) => state.theme.themeTable?.dealingMessageTextColor);
    if (!isShowingDealingMessage ||
        hasStatusMessage ||
        hasCommunityCards ||
        tableAreaDimensionsW === undefined ||
        tableAreaDimensionsH === undefined ||
        !dealingMessageTextColor) {
        return null;
    }
    return (_jsx(DealingMessageDisplay, { text: dealingMessageText, textColor: dealingMessageTextColor, tableAreaDimensionsW: tableAreaDimensionsW, tableAreaDimensionsH: tableAreaDimensionsH }));
};
